/**
 * 画像ギャラリー
 * https://swiperjs.com/
 */

const init = () => {
  new Swiper(".js-projects-detail-gallery", {
    slidesPerView: "auto",
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
};

export { init };
